import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { routes } from './app.routes';
import { authInterceptor } from '@shared/services/auth/auth.interceptor';

registerLocaleData(localeEs, 'es');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    // Animaciones de Angular Material (mat-expansion-panel, mat-menu, dialogs…).
    // `Async` carga el módulo de animaciones lazy para reducir el bundle inicial.
    provideAnimationsAsync(),

    // Conexión única: un solo HttpClient con un solo interceptor de auth.
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),

    { provide: LOCALE_ID, useValue: 'es' },

    // Adaptador de fechas para TODOS los mat-datepicker (Auditoría → Acceso
    // tronaba con "No provider found for DateAdapter" porque su componente
    // no importa MaterialModule). Calendario en español de México.
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
  ],
};
